import { PhoneAnalyticsTypes } from '@frontend/api-analytics';
import { i18next } from '@frontend/i18n';

type Params = {
  filterHintText?: string;
  filters?: PhoneAnalyticsTypes.Filters;
  hasAccessToMultipleLocations?: boolean;
};

export const getPageSubtitleText = ({ filterHintText, filters, hasAccessToMultipleLocations }: Params) => {
  const locationCount = filters?.location_id?.length ?? 0;

  if (!hasAccessToMultipleLocations || locationCount === 0) {
    return filterHintText ?? '';
  }

  // Please note that we cannot have text for "All Locations" as phone analytics is multi brand analytics
  // And the location count cannot be directly compared with locations count from GLS selection
  if (locationCount === 1) {
    return i18next.t('1 Location, {{timePeriod}}', {
      timePeriod: filterHintText,
      ns: 'analytics-phone',
    });
  } else if (locationCount > 1) {
    return i18next.t('{{count}} locations, {{timePeriod}}', {
      count: locationCount,
      timePeriod: filterHintText,
      ns: 'analytics-phone',
    });
  }

  return filterHintText ?? '';
};
